// extracted by mini-css-extract-plugin
export default {"root":"Actions_root__ueziO","placeHolderShimmer":"Actions_placeHolderShimmer__Z91Lf"};